import { useIsFetching } from '@tanstack/react-query';
import { LinearProgress, Box } from '@mui/joy';
import { useEffect, useState } from 'react';

export const GlobalLoadingIndicator = () => {
  const isFetching = useIsFetching();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isFetching > 0) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 200);
      return () => clearTimeout(timer);
    }
  }, [isFetching]);

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        height: '3px',
      }}
    >
      <LinearProgress variant='solid' color='primary' determinate />
    </Box>
  );
};
